import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Translations extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get blogCategoryTranslations() {
    return get(this, '_blog_category_translations', []);
  }

  get NAVIGATION_GET_THE_APP() {
    return get(this, '_navigation_get_the_app.value', '');
  }

  get NAVIGATION_SIGN_IN() {
    return get(this, '_navigation_sign_in.value', '');
  }

  get NAVIGATION_ZONIFERO_PRODUCTS() {
    return get(this, '_navigation_zonifero_products.value', '');
  }
  
  get NAVIGATION_PROPTECH() {
    return get(this, '_navigation_proptech.value', '');
  }

  get NAVIGATION_STORE() {
    return get(this, '_navigation_store.value', '');
  }

  get NAVIGATION_BLOG() {
    return get(this, '_navigation_blog.value', '');
  }

  get NAVIGATION_FAQ() {
    return get(this, '_navigation_faq.value', '');
  }

  get NAVIGATION_WORK() {
    return get(this, '_navigation_work.value', '');
  }

  get BLOG_ABOUT_THE_AUTHOR() {
    return get(this, '_blog_about_the_author.value', '');
  }

  get BLOG_BLOG_AUTHORS() {
    return get(this, '_blog_blog_authors.value', '');
  }

  get BLOG_OTHER_ARTICLES() {
    return get(this, '_blog_other_articles.value', '');
  }

  get BLOG_MORE_ARTICLES() {
    return get(this, '_blog_more_articles.value', '');
  }

  get BLOG_BY() {
    return get(this, '_blog_by.value', '');
  }

  get BLOG_SHARE() {
    return get(this, '_blog_share.value', '');
  }

  get BLOG_DEFAULT_FILTER() {
    return get(this, '_blog_default_filter.value', '');
  }

  get BLOG_HEADER() {
    return get(this, '_blog_header.value', '');
  }

  get FOOTER_ADDRESS_UPPER_LINE() {
    return get(this, '_footer_address_upper_line.value', '');
  }

  get FOOTER_ADDRESS_BOTTOM_LINE() {
    return get(this, '_footer_address_bottom_line.value', '');
  }

  get FOOTER_SOCIAL_MEDIA() {
    return get(this, '_footer_social_media.value', '');
  }

  get FOOTER_PRODUCTS() {
    return get(this, '_footer_products.value', '');
  }

  get FOOTER_ABOUT() {
    return get(this, '_footer_about.value', '');
  }

  get FOOTER_COMPANY() {
    return get(this, '_footer_company.value', '');
  }

  get FORM_CHECKBOX_DATA_PROCESSING_LABEL() {
    return get(this, '_form_checkbox_data_processing_label.value', '');
  }

  get FORM_CHECKBOX_DATA_SENDING_LABEL() {
    return get(this, '_form_checkbox_data_sending_label.value', '');
  }

  get FORM_BUTTON_SUCCESS_MESSAGE() {
    return get(this, '_form_button_success_message.value', '');
  }

  get FORM_BUTTON_ERROR_MESSAGE() {
    return get(this, '_form_button_error_message.value', '');
  }

  get FORM_BUTTON_LOADING_MESSAGE() {
    return get(this, '_form_button_loading_message.value', '');
  }

  get FORM_BUTTON_DEFAULT_MESSAGE() {
    return get(this, '_form_button_default_message.value', '');
  }

  get COOKIES_AGREEMENT() {
    return get(this, '_cookies_agreement.value', '');
  }

  get PRIVACY_POLICY() {
    return get(this, '_privacy_policy.value', '');
  }

  get REGULATIONS() {
    return get(this, '_regulations.value', '');
  }

  get APPLICATION_REGULATIONS() {
    return get(this, '_application_regulations.value', '');
  }

  get FOOTER_PRIVACY_POLICY_LINK() {
    return get(this, '_footer_privacy_policy_link.value', '');
  }

  get FOOTER_REGULATIONS_LINK() {
    return get(this, '_footer_regulations_link.value', '');
  }

  get FOOTER_APPLICATION_REGULATIONS_LINK() {
    return get(this, '_footer_application_regulations_link.value', '');
  }

  get PAGE_NOT_FOUND_TEXT() {
    return get(this, '_page_not_found_text.value', '');
  }

  get LANGUAGE_CHANGE_WARNING() {
    return get(this, '_language_change_warning.value', '');
  }

  get LANGUAGE_CHANGE_WARNING_ACCEPT_BUTTON() {
    return get(this, '_language_change_warning_accept_button.value', '');
  }

  get LANGUAGE_CHANGE_WARNING_CANCEL_BUTTON() {
    return get(this, '_language_change_warning_cancel_button.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Translations.model.js